const SCRIPT_PATTERN = /<\s*script[^>]*>(.*?)<\s*\/\s*script>/gis;
const JS_EVENT_HANDLER_PATTERN = /on\w+\s*=\s*["'][^"']*["']/gi;
const MAX_DEFAULT = 2000;

export const sanitizeInput = (value, maxLength = MAX_DEFAULT) => {
  const normalized = String(value ?? '').trim().slice(0, maxLength);
  return normalized
    .replace(SCRIPT_PATTERN, '')
    .replace(JS_EVENT_HANDLER_PATTERN, '')
    .replace(/[<>]/g, '');
};

export const hasInjectionPattern = (value = '') => {
  const normalized = String(value);
  return /<\s*script[^>]*>(.*?)<\s*\/\s*script>/i.test(normalized) || /on\w+\s*=\s*["'][^"']*["']/i.test(normalized);
};

export const isStrongPassword = (password = '') => {
  const value = String(password);
  if (value.length < 12) return false;

  const hasUpper = /[A-Z]/.test(value);
  const hasLower = /[a-z]/.test(value);
  const hasNumber = /\d/.test(value);
  const hasSymbol = /[^A-Za-z0-9]/.test(value);

  return hasUpper && hasLower && hasNumber && hasSymbol;
};

export const sanitizeConfigOverride = (config = {}) => {
  if (!config || typeof config !== 'object') return {};

  const nextConfig = { ...config };

  if (nextConfig.apiKeys) {
    delete nextConfig.apiKeys;
  }

  if (nextConfig.ai && typeof nextConfig.ai === 'object') {
    const { huggingfaceKey, openrouterKey, ...safeAiConfig } = nextConfig.ai;
    nextConfig.ai = safeAiConfig;
  }

  if (nextConfig.admin && typeof nextConfig.admin === 'object') {
    const { password, ...safeAdminConfig } = nextConfig.admin;
    nextConfig.admin = safeAdminConfig;
  }

  return nextConfig;
};
